var _rect, _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgClock = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    transform: "translate(0 0.5)",
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.6668 9.16634V8.49967H8.00016V9.16634H10.6668Z",
    fill: "#4E525C"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.00016 15.1663C11.6821 15.1663 14.6668 12.1816 14.6668 8.49967C14.6668 4.81778 11.6821 1.83301 8.00016 1.83301C4.31826 1.83301 1.3335 4.81778 1.3335 8.49967C1.3335 12.1816 4.31826 15.1663 8.00016 15.1663ZM8.00016 13.833C10.9457 13.833 13.3335 11.4452 13.3335 8.49967C13.3335 5.55416 10.9457 3.16634 8.00016 3.16634C5.05464 3.16634 2.66683 5.55416 2.66683 8.49967C2.66683 11.4452 5.05464 13.833 8.00016 13.833Z",
    fill: "#4E525C"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10.6668 9.16634V8.49967H8.00016V9.16634H10.6668Z",
    fill: "#4E525C"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M8.00016 4.49967L7.3335 4.49967V9.16634H8.00016V4.49967Z",
    fill: "#4E525C"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgClock);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/clock.00210ef3ec4597618c3cd9f34cc7128a.svg";